import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styles from './ShopifyCallback.module.css';

const ShopifyCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleShopifyCallback } = useAuth();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    const processCallback = async () => {
      const code = searchParams.get('code');
      const shop = searchParams.get('shop');
      const state = searchParams.get('state');

      if (!code || !shop || !state) {
        setStatus('error');
        setError('Missing required parameters');
        return;
      }

      try {
        await handleShopifyCallback(code, shop, state);
        setStatus('success');
        
        // Short delay before redirect to show success message
        setTimeout(() => {
          navigate('/dashboard', { 
            state: { shopifyConnected: true }
          });
        }, 2000);
      } catch (error) {
        setStatus('error');
        setError(error.message || 'Failed to complete Shopify integration');
        
        // Log the error for debugging
        console.error('Shopify callback error:', error);
      }
    };

    processCallback();
  }, [searchParams, navigate, handleShopifyCallback]);

  return (
    <div className={styles.container}>
      {status === 'processing' && (
        <div className={styles.status}>
          <div className={styles.spinner}></div>
          <p>Connecting to Shopify...</p>
        </div>
      )}
      
      {status === 'success' && (
        <div className={styles.success}>
          <h2>✅ Successfully connected to Shopify!</h2>
          <p>Redirecting to dashboard...</p>
        </div>
      )}

      {status === 'error' && (
        <div className={styles.error}>
          <h2>❌ Connection Failed</h2>
          <p>{error}</p>
          <button 
            onClick={() => navigate('/dashboard')}
            className={styles.button}
          >
            Return to Dashboard
          </button>
        </div>
      )}
    </div>
  );
};

export default ShopifyCallback; 